module.exports = __webpack_public_path__ + "img/vippack_dfod_dg.bfab900f.png";